import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { UitkCardFeaturedHeader } from 'uitk-react-cards';
import { ActivityDestinationViewSearch } from '../../../../../../common/__generated__/api';

export interface ActivitySpannedTileCardFeatureHeaderProps {
  activity: ActivityDestinationViewSearch.ActivityInlineFragment;
}

export const ActivitySpannedTileCardFeatureHeader = ({
  activity
}: ActivitySpannedTileCardFeatureHeaderProps): JSX.Element | null => {
  if (activity.features.pinnedTopBottom && activity.features.pinnedTopBottom.tileTop) {
    return (
      <Experiment name="LX_PWA_Pinned_Activity_FeaturedHeader">
        <ExperimentControl>
          <UitkCardFeaturedHeader
            className="uitk-type-heading-300"
            title={{ tag: 'h4', text: activity.features.pinnedTopBottom.tileTop.description }}
            data-testid="activity-spanned-tile-card-pinned-top-bottom-tile-top"
          />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <UitkCardFeaturedHeader
            title={{ tag: 'h4', text: activity.features.pinnedTopBottom.tileTop.description }}
            data-testid="activity-spanned-tile-card-pinned-top-bottom-tile-top-variant"
          />
        </ExperimentVariant>
      </Experiment>
    );
  }

  return null;
};
